import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/what-is-saint-depression-treatment")({
  beforeLoad: () => {
    throw redirect({
      to: "/learn/$slug",
      params: { slug: "what-is-saint-treatment-for-depression" },
      replace: true,
    });
  },
});
